import type { RouteRecordRaw } from "vue-router";

const paymentsRoutes: RouteRecordRaw[] = [
  {
    path: "/payment/create",
    name: "create-payment",
    component: () => import("@/views/Payments/CreatePayment.vue"),
    meta: {
      title: "Make a Payment",
      requiresAuth: true,
      paymentsPermission: "createPayment",
    },
  },
  {
    path: "/payment/automaticPayments",
    name: "automatic-payments",
    component: () => import("@/views/Payments/ViewAutoPayments.vue"),
    meta: {
      title: "Automatic Payments",
      requiresAuth: true,
      paymentsPermission: "autoPayments",
    },
  },
  {
    path: "/payment/pending",
    name: "pending-payments",
    component: () => import("@/views/Payments/ViewPendingPayments.vue"),
    meta: {
      title: "Pending Payments",
      requiresAuth: true,
      paymentsPermission: "pendingPayments",
    },
  },
  {
    path: "/payment/sources",
    name: "payment-sources",
    component: () => import("@/views/Payments/ViewPaymentSources.vue"),
    meta: {
      title: "Payment Sources",
      requiresAuth: true,
      paymentsPermission: "paymentSources",
    },
  },
  {
    path: "/payment/history",
    name: "payment-history",
    component: () => import("@/views/Payments/ViewPaymentHistory.vue"),
    meta: {
      title: "Payment History",
      requiresAuth: true,
      paymentsPermission: "paymentHistory",
    },
  },
];

export default paymentsRoutes;
